import { Card, Stack, styled } from "@mui/material";

export const SimmerCardWrapper = styled(Card)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    width: "100%",
    padding: "20px",
    margin: "15px",
    borderRadius: "16px", // MUI dashboard standard
    border: "1px solid #E0E0E0",
    boxShadow: "none",
}));

export const SimmerCardWrapperTimer = styled(Card)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    padding: "20px",
    width: "100%",
    marginInline: "15px",
    borderRadius: "16px",
    border: "1px solid #E0E0E0",
    boxShadow: "none",
}));
export const SimmerCardWrapperVertical = styled(Card, {
    shouldForwardProp: (prop) => prop !== 'marginBottom',
})(({ theme, marginBottom }) => ({
    display: "flex",
    justifyContent: "center",
    padding: "20px",
    width: "100%",
    marginBottom: marginBottom ? marginBottom : "",
    borderRadius: "16px",
    border: "1px solid #E0E0E0",
    boxShadow: "none",
}));

export const CustomBox = styled(Stack)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
}));